/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

///////////////////////////////////////////////////////////
/////////////////// BAND MATH /////////////////////////////
///////////////////////////////////////////////////////////

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements, getAllowedOutputs } from '../block_compatibility_checks';

Blockly.Blocks['analyse_single_band_math'] = {
  init: function () {
    this.appendValueInput("input")
      .appendField("Band math:     ")
      .setCheck(getAllowedStatements('band_math_input'))
    this.setInputsInline(false);
    this.setPreviousStatement(true, 'band_math_input');
    this.setNextStatement(true, getAllowedOutputs('band_math_input'));
    this.setStyle('bandMath');
    this.setTooltip(Blockly.Msg.SINGLE_BAND_MATH_BLOCK_TOOLTIP);
   this.setHelpUrl("");
  },
};